export default __webpack_public_path__ + "static/media/Screenshot.eca16bc1.png";